export default {"src":"/_next/static/media/calendar.9b53a373.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};